module.exports = __webpack_public_path__ + "7a669eac624a433ebcf42699c2e5136a.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/border-icon.png
// module id = 192
// module chunks = 0